module.exports = __webpack_public_path__ + "img/logo72.1b45009e.png";